// (A) 중립 Tabs API — antd 미접촉. (B) PlainTabs(플레인) 에 위임.
import type {
  CSSProperties,
  ReactNode,
  MouseEvent as ReactMouseEvent,
  KeyboardEvent as ReactKeyboardEvent,
} from 'react'
import { PlainTabs } from '../_impl/PlainTabs'

export interface OmwTabItem {
  key: string
  label: ReactNode
  children?: ReactNode
  disabled?: boolean
  forceRender?: boolean
  closable?: boolean
  closeIcon?: ReactNode
  icon?: ReactNode
}

export type OmwTabsEditAction = 'add' | 'remove'

export type OmwTabBarExtraContent = ReactNode | { left?: ReactNode; right?: ReactNode }

export interface OmwTabsProps {
  items: OmwTabItem[]
  activeKey?: string
  defaultActiveKey?: string
  onChange?: (key: string) => void
  onTabClick?: (key: string, event: ReactMouseEvent | ReactKeyboardEvent) => void
  tabBarExtraContent?: OmwTabBarExtraContent
  centered?: boolean
  destroyOnHidden?: boolean
  type?: 'line' | 'editable-card'
  tabPosition?: 'top' | 'bottom' | 'left' | 'right'
  hideAdd?: boolean
  onEdit?: (targetKey: string, action: OmwTabsEditAction) => void
  className?: string
  style?: CSSProperties
  'aria-label'?: string
}

export function OmwTabs(props: OmwTabsProps) {
  return <PlainTabs {...props} />
}
